export const OTPService = {
    postOTP,
    postVerifyOTP
}

const { REACT_APP_CREDIT_SERVICE_API_BASE_URL } = process.env;

function postOTP(OTP, TOKEN) {
    const requestOptions = {
        method: 'POST',
        headers: { "Authorization": TOKEN, 'Content-Type': 'application/json' },
        body: JSON.stringify(OTP)
    };
    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/credit/send_otp`, requestOptions).then(handleResponse);
}

function postVerifyOTP(OTP, TOKEN) {
    const requestOptions = {
        method: 'POST',
        headers: { "Authorization": TOKEN, 'Content-Type': 'application/json' },
        body: JSON.stringify(OTP)
    };
    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/credit/verify_otp`, requestOptions).then(handleResponse);
}

function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            // if (response.status === 401) {
            //     logout();
            // }
            const error = (data && data.errors) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}